import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/loader.svg'


_pushScopeId("data-v-7eb78251")
const _hoisted_1 = { class: "modal-header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "form-group" }, " We'll save your design for you, so you can order today, tomorrow, or even next year, and all your hard work will be safe with us. ", -1)
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { for: "save-artwork" }, "Design Name", -1)
const _hoisted_5 = {
  key: 1,
  id: "loading-wrap"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloseSVG = _resolveComponent("CloseSVG")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.fadeTransition, "modal"])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass([_ctx.bounceTransition, "modal-body"])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("h1", null, _toDisplayString(_ctx.title), 1),
          _createElementVNode("div", {
            style: {"height":"30px","width":"30px"},
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
          }, [
            _createVNode(_component_CloseSVG, { propId: 'save-label-close' })
          ])
        ]),
        _createElementVNode("form", {
          onSubmit: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"]))
        }, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _withDirectives(_createElementVNode("input", {
              id: "save-artwork",
              class: "form-input",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.artworkName = $event)),
              required: ""
            }, null, 512), [
              [_vModelText, _ctx.artworkName]
            ])
          ]),
          _createElementVNode("div", {
            style: _normalizeStyle({
              visibility: _ctx.userArtworkFetch.artwork && !_ctx.saveAsNew ? undefined : 'hidden',
              color: '#0dc5e1',
              fontWeight: 700,
            }),
            class: "form-group"
          }, [
            _createElementVNode("span", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.saveAsNew = true))
            }, "Save as New Design")
          ], 4),
          (!_ctx.loading)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                "aria-label": "Submit save label",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleSaveArtwork && _ctx.handleSaveArtwork(...args))),
                class: "modal-select-btn",
                type: "submit"
              }, "Save"))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
        ], 32)
      ], 2)
    ], 2)
  ]))
}